import enTranslations from '../../assets/i18n/en.json';
import esTranslations from '../../assets/i18n/es.json';
import frTranslations from '../../assets/i18n/fr.json';
import zhTranslations from '../../assets/i18n/zh.json';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GetText {
  private static instance: GetText;
  private dictionary: { [key: string]: string } = {};

  private static readonly translations = {
    en: enTranslations,
    es: esTranslations,
    fr: frTranslations,
    zh: zhTranslations,
  };

  private constructor() {
    // Initialize with English as default
    this.loadDictionary('en');
  }

  public static getInstance(): GetText {
    if (!GetText.instance) {
      GetText.instance = new GetText();
    }
    return GetText.instance;
  }

  loadDictionary(lang: string): void {
    if (lang in GetText.translations) {
      this.dictionary = GetText.translations[lang as keyof typeof GetText.translations] as { [key: string]: string };
    } else {
      this.dictionary = GetText.translations.en as { [key: string]: string }; // Fallback to English
    }
  }

  getTranslation(key: string): string {
    return this.dictionary[key] || key;
  }
}
